exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.van-nav-bar .van-nav-bar__right{left:0 !important\n}\n", "", {"version":3,"sources":["/bitnami/jenkins/home/workspace/web-app.superex.com/src/view/purchase/index.vue"],"names":[],"mappings":";AAAA,iCAAiC,iBAAiB;CAAC","file":"index.vue","sourcesContent":[".van-nav-bar .van-nav-bar__right{left:0 !important}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?sourceMap!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-42f38cb6","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/view/purchase/index.vue
// module id = hDDA
// module chunks = 0